import * as $ from 'jquery';
import './PolyFills';
import ScrollMagic from 'scrollmagic';
import KVSection from "./sections/KVSection";
import VideoIntroSection from "./sections/VideoIntroSection";
import VideoSection from "./sections/VideoSection";
import ModelSection from "./sections/ModelSection";
import KaleSection from "./sections/KaleSection";
import AfterModelSection from "./sections/AfterModelSection";
import FeatureSection from "./sections/FeatureSection";
import SloganSection from "./sections/SloganSection";
import RippleSection from "./sections/RippleSection";
import FormSection from "./sections/FormSection";
import app from "./components/AddressSelectList"
import {
  kaleInit
} from "./components/kaleidoscope.js";
import isMobile from 'ismobilejs';



var stgH;
// device detection

$(function() {

  // console.log();

  var formNum = 0;
  if ((window.innerWidth / window.innerHeight) > (1920 / 1320)) {
    $('.container_w1920').css({
      "width": "100%",
      "height": "100%"
    });

  } else {
    $('.container_w1920').css({
      "width": "145vh",
      "height": "100%"
    });
  }


  createScrollController();
  createSection();

    //
  stgH = window.innerHeight;
  console.log('stgH',stgH);
  $(window).on('resize', windowResizeHandler);


  //
  $('.feature').css('margin-top', -1 * window.innerHeight + "px");
  $('.slogan').css('margin-top', -1 * window.innerHeight + "px");
  $('.video').css('margin-top', -2 * window.innerHeight + "px");
  $('.videointro').css('margin-top', (60 - window.innerHeight) + "px");
  $('.app_section').css('min-height', window.innerHeight + "px");
  $('.app_section_content').css("height", window.innerHeight + "px");
  $('.app_section_content_flow').css({
    "height": window.innerHeight + "px",
    "top": window.innerHeight + "px"
  });
  $('.trigger').each(function(index, el) {
    var h = $(el).css('height')*0.75;
    $(el).css('height', $(el).css('height'), h + "px");
  });

  $('.menu').on("click", function() {
    $('.menu-btn').trigger("click");
  })

  $('#btn_info').on('click', function() {
    var featureTop = $("#feature").offset().top + window.innerHeight;
    $('html, body').animate({
      scrollTop: featureTop
    }, 50);
  })

  $(window).scroll(function() {
    var scrollVal = $(this).scrollTop();
    // if (scrollVal > window.innerHeight && scrollVal < ($('.feature__bg--skin').offset().top - window.innerHeight)) {
    //   $('.cta').addClass("fix");
    //   $('.cta').fadeIn();
    // } else {
    //   $('.cta').removeClass("fix");
    // }
  });
  kaleInit();
  init();


});

function init() {

  $('#ripple__bg').ripples({
    resolution: 512,
    dropRadius: 25,
    perturbance: 0.04,
    interactive: false,
    crossOrigin: "Anonymous",
    imageUrl: $('.ripple__img').src
  });
}

function windowResizeHandler(e) {
  if (isMobile(navigator.userAgent).apple.device || isMobile(navigator.userAgent).android.device) {
    console.log('resizing',stgH,window.innerHeight);
    if (stgH > window.innerHeight) {
      console.log('resizeToSmall',stgH,window.innerHeight);
    } else {
      console.log('resizeTobigger',stgH,window.innerHeight);
      stgH = window.innerHeight;

      $('.feature').css('margin-top', -1 * window.innerHeight + "px");
      $('.slogan').css('margin-top', -1 * window.innerHeight + "px");
      $('.video').css('margin-top', -2 * window.innerHeight + "px");
      $('.videointro').css('margin-top', (60 - window.innerHeight) + "px");
      $('.app_section').css('min-height', window.innerHeight + "px");
      $('.app_section_content').css("height", window.innerHeight + "px");
      $('.app_section_content_flow').css({
        "height": window.innerHeight + "px",
        "top": window.innerHeight + "px"
      });
      $('.trigger').each(function(index, el) {
        var h = $(el).css('height');
        $(el).css('height', $(el).css('height'), h + "px");
      });
    }
  } else {
    location.reload();
  }

  if ((window.innerWidth / window.innerHeight) > (1920 / 1320)) {

    $('.container_w1920').css({
      "width": "100%",
      "height": "100%"
    });

  } else {
    $('.container_w1920').css({
      "width": "145vh",
      "height": "100%"
    });
  }
  if (renderArr && renderArr.length) {
    renderArr.map(item => {
      item.target.resizeHandler();
    });
  }

  // if(window.innerWidth < 1024 && formNum ==3 ){
  //   $('.app_section_content_flow').css({"position":"absolute","top":"100vh"})
  // }
  // else{
  //   $('.app_section_content_flow').css({"position":"fixed","top":"0"})
  // }
}


/*
 * ScrollMagic Controller
 * */
let controller;

function createScrollController() {
  controller = new ScrollMagic.Controller();
}


/*
 * Create Sections
 * */
const renderArr = [{
    tagName: '#kv',
    class: KVSection,
    target: null
  },
  {
    tagName: '#kaleidoscope',
    class: KaleSection,
    target: null
  },
  {
    tagName: '#videoIntro',
    class: VideoIntroSection,
    target: null
  },
  {
    tagName: '#video',
    class: VideoSection,
    target: null
  },
  {
    tagName: '#model',
    class: ModelSection,
    target: null
  },
  {
    tagName: '#afterModel',
    class: AfterModelSection,
    target: null
  },
  {
    tagName: '#feature',
    class: FeatureSection,
    target: null
  },
  {
    tagName: '#slogan',
    class: SloganSection,
    target: null
  },
  {
    tagName: '#ripple',
    class: RippleSection,
    target: null
  },
  {
    tagName: '#form',
    class: FormSection,
    target: null
  },
];

function createSection() {
  renderArr.map((item) => {
    const CurrentClass = item.class;
    const section = new CurrentClass(document.querySelector(item.tagName), controller);
    console.log(section);
    section.createScrollEffect();
    item.target = section;
  });
}
